import { State } from "@/store/modules/meeting/index";
import {
  AttendeeInterface,
  MeetingInterface,
} from "@/resources/interfaces/meetingInterfaces";

const getOpenDevicesConfig = (state: State): boolean => {
  return state.openDevicesConfig;
};

const getOpenBackgroundImages = (state: State): boolean => {
  return state.openBackgroundImages;
};

const getSelectedVideoInput = (state: State) => {
  return state.selectedVideoInput;
};

const getSelectedAudioInput = (state: State) => {
  return state.selectedAudioInput;
};

const getSelectedAudioOutput = (state: State) => {
  return state.selectedAudioOutput;
};

const getMeeting = (state: State): MeetingInterface | null => {
  return state.meeting;
};

const getAttendee = (state: State): AttendeeInterface | null => {
  return state.attendee;
};

const getMeetingSession = (state: State) => {
  return state.meetingSession;
};

const getCameraEnabled = (state: State): boolean => {
  return state.cameraEnabled;
};

const getMicEnabled = (state: State): boolean => {
  return state.micEnabled;
};

const getColumnDisplay = (state: State): boolean => {
  return state.columnDisplay;
};

const getSharedScreenEnabled = (state: State): boolean => {
  return state.shareScreenEnabled;
};

const getActiveParticipant = (state: State) => {
  return state.activeParticipant;
};

const getVideoUrl = (state: State) => {
  return state.videoUrl;
};

const getMeetingType = (state: State) => {
  return state.meetingType;
};

const getOpenWebinarUrl = (state: State) => {
  return state.openWebinarUrl;
};

const getRoomIdWebinarUpdate = (state: State) => {
  return state.roomIdWebinarUpdate;
};

const getRoomId = (state: State): number => {
  return state.roomId;
};

const getWebinarActive = (state: State): boolean => {
  return state.webinarActive;
};

const getBackgroundProcessors = (state: State) => {
  return state.backgroundProcessors;
};

const getBackgroundIsSupported = (state: State): boolean => {
  return state.backgroundIsSupported;
};

const getBackgroundImage = (state: State): string => {
  return state.backgroundImage;
};

const getBackgroundEnabled = (state: State): boolean => {
  return state.backgroundEnabled;
};

const getBlurEnabled = (state: State): boolean => {
  return state.blurEnabled;
};

const getBlurAmount = (state: State): number => {
  return state.blurAmount;
};

const getBlurProcessors = (state: State) => {
  return state.blurProcessors;
};

const getTransformDevice = (state: State) => {
  return state.transformDevice;
};

const getBlurIsSupported = (state: State) => {
  return state.blurIsSupported;
};

const getVoiceTransformDevice = (state: State) => {
  return state.voiceTransformDevice;
};

const getVoiceIsEnabled = (state: State) => {
  return state.voiceIsEnabled;
};

const getVoiceIsSupported = (state: State) => {
  return state.voiceIsSupported;
};

const getPressToTalkEnabled = (state: State) => {
  return state.pressToTalkEnabled;
};

const getUsersInCall = (state: State) => {
  return state.usersInCall;
};

const getIsFirstConnection = (state: State) => {
  return state.isFirstConnection;
};

const getCallIsRecord = (state: State) => {
  return state.callIsRecord;
};

const getActiveGame = (state: State) => {
  return state.activeGame;
};

const getRoomName = (state: State): string => {
  return state.roomName;
};

const getOpenMeetingUrl = (state: State): boolean => {
  return state.openMeetingrUrl;
};

const getIsVideoUrlLockedByAdmin = (state: State): boolean => {
  return state.isVideoUrlLockedByAdmin;
};

const getLayoutType = (state: State) => {
  return state.layoutType;
};

const getShowCallModal = (state: State): boolean => {
  return state.showCallModal;
};

const getShowCallFromSpaceUser = (state: State) => {
  return state.showCallFromSpaceUser;
};

const getFocusMode = (state: State) => {
  return state.focusMode;
};

const getCountPlayerInCall = (state: State): number => {
  return state.countPlayerInCall;
};

const getRoomAutoVideoId = (state: State): any => {
  return state.roomAutoVideoId;
};

export default {
  getOpenDevicesConfig,
  getOpenBackgroundImages,
  getSelectedAudioInput,
  getSelectedVideoInput,
  getSelectedAudioOutput,
  getMeeting,
  getAttendee,
  getMeetingSession,
  getCameraEnabled,
  getMicEnabled,
  getColumnDisplay,
  getSharedScreenEnabled,
  getActiveParticipant,
  getVideoUrl,
  getMeetingType,
  getOpenWebinarUrl,
  getRoomIdWebinarUpdate,
  getRoomId,
  getWebinarActive,
  getBackgroundProcessors,
  getBackgroundIsSupported,
  getBackgroundImage,
  getBackgroundEnabled,
  getBlurEnabled,
  getBlurAmount,
  getBlurProcessors,
  getTransformDevice,
  getBlurIsSupported,
  getVoiceTransformDevice,
  getVoiceIsEnabled,
  getVoiceIsSupported,
  getPressToTalkEnabled,
  getUsersInCall,
  getIsFirstConnection,
  getCallIsRecord,
  getActiveGame,
  getRoomName,
  getOpenMeetingUrl,
  getIsVideoUrlLockedByAdmin,
  getLayoutType,
  getShowCallModal,
  getShowCallFromSpaceUser,
  getFocusMode,
  getCountPlayerInCall,
  getRoomAutoVideoId,
};
